import Select from "../../../../form/Select";
import React from "react";
import isEqual from "lodash-es/isEqual";
import {optionsTemplate} from "../../../../../utils/formatters";

export class Source extends React.Component {

    componentDidUpdate(prevProps, prevState, prevContext) {
        const propsTop = {...this.props};
        const {props} = propsTop;
        const prevPropsTop = {...prevProps};
        const pProps = prevPropsTop.props;
        if (isEqual(props.values.id + "", (pProps || {}).id + "") && !isEqual((props.values.seller || {}).partner_id, (((pProps || {}).values.seller) || {}).partner_id)) {
            props.setFieldValue("source", null);
        }
    }

    render() {
        const propsTop = {...this.props};
        const {props, state, parent} = propsTop;
        const {hidden, labels} = props;
        return (hidden || []).indexOf("source") === -1 && (!!props.values.seller || this.props.visible) ? <Select
            label={labels.source || "Honnan"}
            name="source"
            component="location"
            objectValue={true}
            labelKey="name"
            storeType="bound"
            boundField={this.props.boundField || "partner"}
            boundValue={this.props.boundValue || (props.values.seller && props.values.seller.partner_id)}
            optionsTemplate={optionsTemplate("location")}
            {...props.getProps("source")}
            value={props.getValue("source")}
            saveChanges={props.setFieldValue}
        /> : null;
    }
}

export default Source;